import { useState } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { compose, map, values } from 'ramda'
import { Dropdown } from '@machobear/design-system'

import { useStateData } from '@/lib/locations'

const ProvinceDropdown = ({ value }) => {
  const { t } = useTranslation()
  const [selection, setSelection] = useState(value)
  const stateData = useStateData()
  const router = useRouter()

  const options = compose(
    values,
    map(option => ({ label: option.name, value: option.slug }))
  )(stateData)

  return (
    <Dropdown
      label={t('states:Select state/province')}
      onChange={val => {
        setSelection(val)
        router.push(`/rental-listings/${val}`)
      }}
      value={selection}
      options={options}
    />
  )
}

export default ProvinceDropdown
